import { ReactNode } from "react";
import { ViewerShell } from "../shared/ViewerShell";

type ImageAdapterProps = {
  url: string;
  fileName?: string;
  nav?: ReactNode;
  isToolbarActive?: boolean;
};

export const ImageAdapter = ({
  url,
  fileName,
  nav,
  isToolbarActive,
}: ImageAdapterProps) => (
  <ViewerShell
    url={url}
    fileName={fileName}
    nav={nav}
    isToolbarActive={isToolbarActive}
  >
    <img src={url} alt="Document" className="doc-viewer-image" draggable={false} />
  </ViewerShell>
);
